import { DatePicker } from "@gravity-ui/date-components";
import { dateTimeParse } from "@gravity-ui/date-utils";
import { Flex } from "@gravity-ui/uikit";
import { Control, Controller, useWatch } from "react-hook-form";

import { ProductFilters } from "../../ProductFilters";

const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";

export interface CreatedAtRangeInputsProps {
  control: Control<ProductFilters>;
  fromPlaceholder?: string;
  toPlaceholder?: string;
  onCommit: () => void;
}

interface CreatedDateInputProps {
  name: "createdFrom" | "createdTo";
  control: Control<ProductFilters>;
  placeholder?: string;
  minValue?: Date;
  maxValue?: Date;
  onCommit: () => void;
}

const CreatedDateInput = ({
  name,
  control,
  placeholder,
  minValue,
  maxValue,
  onCommit,
}: CreatedDateInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <DatePicker
            name={field.name}
            format={DISPLAY_DATE_FORMAT}
            placeholder={placeholder}
            hasClear
            value={dateTimeParse(field.value) ?? null}
            minValue={dateTimeParse(minValue)}
            maxValue={dateTimeParse(maxValue)}
            onUpdate={(value) => {
              field.onChange(value?.toDate());
            }}
            onBlur={onCommit}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                onCommit();
              }
            }}
            onOpenChange={(_open, reason) => {
              if (reason === "ValueSelected") {
                onCommit();
              }
            }}
          />
        );
      }}
    />
  );
};

export const CreatedAtRangeInputs = ({
  control,
  fromPlaceholder,
  toPlaceholder,
  onCommit,
}: CreatedAtRangeInputsProps) => {
  const createdFrom = useWatch({ control, name: "createdFrom" });
  const createdTo = useWatch({ control, name: "createdTo" });

  return (
    <Flex direction={"column"} gap={2}>
      <CreatedDateInput
        name="createdFrom"
        control={control}
        placeholder={fromPlaceholder}
        maxValue={createdTo}
        onCommit={onCommit}
      />
      <CreatedDateInput
        name="createdTo"
        control={control}
        placeholder={toPlaceholder}
        minValue={createdFrom}
        onCommit={onCommit}
      />
    </Flex>
  );
};
